// Hook to fetch/put/post/delete the /usernameRef/bulk response

/*  Shared  */
import { Notify } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import { useCallback, useState } from 'react';

export const usePutUsernameRefBulk = (t) => {
    const [saving, setSaving] = useState(false);

    const putUsernameRefBulk = useCallback(
        async ({ params }) => {
            try {
                setSaving(true);

                await axios.put('/usernameRef/bulk', params);
                Notify.success(
                    t('GlobalAdmin.Applications.usernameRefs.updated')
                );
                setSaving(false);
                return true; // success = true
            } catch (err) {
                debug.e('Unable to update username refs.', err);
                Notify.error(
                    t('GlobalAdmin.Applications.usernameRefs.notUpdated')
                );
                setSaving(false);
                return false; // success = false
            }
        },
        [t]
    );

    return { putUsernameRefBulk, saving };
};

export const usePostUsernameRefBulk = (t) => {
    const [saving, setSaving] = useState(false);

    const postUsernameRefBulk = useCallback(
        async ({ params }) => {
            try {
                setSaving(true);
                await axios.post('/usernameRef/bulk', params);
                Notify.success(
                    t('GlobalAdmin.Applications.usernameRefs.added')
                );
                setSaving(false);
                return true; // success = true
            } catch (err) {
                debug.e('Unable to add username refs.', err);
                Notify.error(
                    t('GlobalAdmin.Applications.usernameRefs.notAdded')
                );
                setSaving(false);
                return false; // success = false
            }
        },
        [t]
    );

    return { postUsernameRefBulk, saving };
};

export const useDeleteUsernameRefBulk = ({ t }) => {
    const [saving, setSaving] = useState(false);

    const deleteUsernameRefBulk = useCallback(
        async ({ params }) => {
            try {
                setSaving(true);
                await axios.delete('/usernameRef/bulk', params);
                Notify.success(
                    t('GlobalAdmin.Applications.usernameRefs.deleted')
                );
                setSaving(false);
                return true; // success = true
            } catch (err) {
                debug.e('Unable to delete username refs.', err, params.id);
                Notify.error(
                    t('GlobalAdmin.Applications.usernameRefs.notDeleted')
                );
                setSaving(false);
                return false; // success = false
            }
        },
        [t]
    );

    return { deleteUsernameRefBulk, saving };
};
